import { AutogenModelGroupMembership, AutogenRowGroupMembership } from "./autogen/AutogenModelGroupMembership";

export class ModelGroupMembership extends AutogenModelGroupMembership<RowGroupMembership> {
	constructor() {
		super(RowGroupMembership);
	}
}

export class RowGroupMembership extends AutogenRowGroupMembership {
}